import { Directive, AfterViewInit, ElementRef, ChangeDetectorRef, Input } from "@angular/core";

@Directive({
    selector: "[appFocus]"
})
export class FocusDirective implements AfterViewInit {
    
    @Input()
    appFocusEnabled: boolean = true;
    
    constructor(private host: ElementRef,
                private changeDetector: ChangeDetectorRef) {
    }

    ngAfterViewInit() {
        this.host.nativeElement.focus();
        this.changeDetector.detectChanges();
    }
}